import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

export function useCurrentUserHasGradProgram(): boolean {
  const { user } = useUserEnvironment();
  return Boolean(user?.orgs.some((org) => org.hasGradProgram));
}
